var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { combineReducers } from "redux";
import AppReducer from "../app-ducks";
import SurvayReducer from "@codex/pages/Survay/ducks";
import BlockUiReducer from "@codex/containers/BlockUi/ducks";
import AuthReducer from "@codex/components/LoginForm/ducks";
import { routerReducer } from 'react-router-redux';
var rootReducers = combineReducers(__assign(__assign(__assign(__assign(__assign({}, AppReducer), SurvayReducer), BlockUiReducer), AuthReducer), { routing: routerReducer }));
export default rootReducers;



//////////////////
// WEBPACK FOOTER
// ./src/store/rootReducers.ts
// module id = 601
// module chunks = 0